import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

import {
	BarcodeCapture,
	barcodeCaptureLoader,
	BarcodeCaptureFeedback,
	BarcodeCaptureOverlay,
	BarcodeCaptureSettings,
	Symbology,
} from "scandit-web-datacapture-barcode";

import {
	Camera,
	CameraPosition,
	CameraSwitchControl,
	configure,
	DataCaptureContext,
	DataCaptureView,
	FrameSourceState,
	LaserlineViewfinder,
	Feedback,
	MarginsWithUnit,
	NumberWithUnit,
	MeasureUnit,
	VideoResolution,
} from "scandit-web-datacapture-core";


export function createSDKFacade() {

let context;
let view;
let laserLineViewFinder;
let settings;
let barcodeCapture;
let overlay;
let host;
let cameraSwitchControl;
let camera;


function createHostElementIfNeeded() {
    if (!host) {
		host = document.createElement("div");
		host.style.display = "none";
		host.style.width = "100%";
		host.style.height = "100%";
		document.body.append(host);
    }
    return host;
}


return {
    async initialize() {

		console.log("【scandit】initialize");

		//ホスト
		const domain = window.location.host;
		console.log("【scandit】domain: " + domain);

		//ライセンス
		if(domain === "okaimono-miniapp.regigo.jp"){
			console.log("【scandit】domain: " + domain);
			await configure({
				licenseKey: process.env.REACT_APP_SCANDIT_LICENSE_PRO,
				// libraryLocation: new URL("https://xxx:xxxx@miniapp.irs-test.jp/library/engine/", document.baseURI).toString(),
				// libraryLocation: new URL("https://cdn.jsdelivr.net/npm/scandit-web-datacapture-barcode@6.24.1/build/engine/", document.baseURI).toString(),
				libraryLocation: new URL("library/engine/", document.baseURI).toString(),
				moduleLoaders: [barcodeCaptureLoader()],
			});
		}else if(domain === "okaimono-miniapp.irs-test.jp"){
			console.log("【scandit】domain: " + domain);
			await configure({
				licenseKey: process.env.REACT_APP_SCANDIT_LICENSE_DEV,
				// libraryLocation: new URL("https://cdn.jsdelivr.net/npm/scandit-web-datacapture-barcode@6.24.1/build/engine/", document.baseURI).toString(),
				libraryLocation: new URL("library/engine/", document.baseURI).toString(),
				moduleLoaders: [barcodeCaptureLoader()],
			});
		}else if(domain === "okaimono.testdrives.dev"){
			console.log("【scandit】domain: " + domain);
			await configure({
				licenseKey: process.env.REACT_APP_SCANDIT_LICENSE_TEST,
				// libraryLocation: new URL("https://cdn.jsdelivr.net/npm/scandit-web-datacapture-barcode@6.24.1/build/engine/", document.baseURI).toString(),
				libraryLocation: new URL("library/engine/", document.baseURI).toString(),
				moduleLoaders: [barcodeCaptureLoader()],
			});
		}

		context = await DataCaptureContext.create();
		settings = new BarcodeCaptureSettings();
		settings.enableSymbologies([
			Symbology.Code128,
			Symbology.EAN8,
			Symbology.EAN13UPCA,
			Symbology.UPCE,
			Symbology.QR,
		]);
		// codeDuplicateFilter を設定（1000ミリ秒間フィルタリング）
		settings.codeDuplicateFilter = 1000;

		//隠し設定有効化
		// const settings = new BarcodeCaptureSettings();
		settings.setProperty("enable_add_on_detector", true);

	  	//雑誌コード13桁 + addon5桁（OLD
		// const ean13upcaSettings = settings.settingsForSymbology(Symbology.EAN13UPCA);
		// ean13upcaSettings.isEnabled = true;
		// ean13upcaSettings.setExtensionEnabled("five_digit_add_on", true);

		//雑誌コード13桁 + addon5桁（NEW
		const symbologySettings = settings.settingsForSymbology(Symbology.EAN13UPCA);
		symbologySettings.setExtensionEnabled("five_digit_add_on", true);

		view = await DataCaptureView.forContext(context);
		view.connectToElement(createHostElementIfNeeded());
		view.logoStyle = "minimal";

    //   cameraSwitchControl = new CameraSwitchControl();
    //   view.addControl(cameraSwitchControl);

		barcodeCapture = await BarcodeCapture.forContext(context, settings);
		await barcodeCapture.setEnabled(false);


		//バイブ、サウンド
		const feedback = BarcodeCaptureFeedback.default;
		feedback.success = new Feedback(null, null);
		await barcodeCapture.setFeedback(feedback);

		//オーバーレイ：追跡枠
		// overlay = await BarcodeCaptureOverlay.withBarcodeCaptureForView(barcodeCapture, view);
		// laserLineViewFinder = new LaserlineViewfinder();
		// await overlay.setViewfinder(laserLineViewFinder);
		// await view.addOverlay(overlay);

		//オーバーレイ：有効範囲の枠線
		// await overlay.setShouldShowScanAreaGuides(true);

		//カメラ設定：FullHD
		// camera = Camera.default;
		// const cameraSettings = BarcodeCapture.recommendedCameraSettings;
		// // cameraSettings.preferredResolution = VideoResolution.FullHD;
		// cameraSettings.preferredResolution = VideoResolution.HD;
		// await camera.applySettings(cameraSettings);
		// await context.setFrameSource(camera);

		// カメラ設定：背面優先 + FullHD
		try {
			// 1) 背面(world-facing)を明示指定
			camera = await Camera.atPosition?.(CameraPosition?.WorldFacing ?? "worldFacing");
		} catch (_) {
			camera = undefined;
		}
		// 2) フォールバック（取得できなければ default）
		if (!camera) {
			camera = Camera.default;
		}
		const cameraSettings = BarcodeCapture.recommendedCameraSettings;
		cameraSettings.preferredResolution = VideoResolution.FullHD;
		// cameraSettings.preferredResolution = VideoResolution.HD;
		await camera.applySettings(cameraSettings);
		await context.setFrameSource(camera);

    },
	async setScanArea(rect,viewRect){
		//スキャンエリア
		// view.scanAreaMargins = new SDCCore.MarginsWithUnit(
		// 	new SDCCore.NumberWithUnit(22, SDCCore.MeasureUnit.Pixel),
		// 	new SDCCore.NumberWithUnit(83, SDCCore.MeasureUnit.Pixel),
		// 	new SDCCore.NumberWithUnit(22, SDCCore.MeasureUnit.Pixel),
		// 	new SDCCore.NumberWithUnit(200, SDCCore.MeasureUnit.Pixel)
		// );

		// const scannerArea = document.getElementById("barcode-scanner-area");
		// if (scannerArea) {
			// const rect = scannerArea.getBoundingClientRect();
			// const viewRect = document.getElementById("barcode-scanner").getBoundingClientRect();
			// const vScanBox = document.getElementById("scanBox").getBoundingClientRect();

				console.log("viewRect:"+viewRect.height);
				console.log("rect.bottom:"+rect.bottom);
				console.log("rect.bottom - viewRect.bottom:"+(rect.bottom - viewRect.bottom));
				console.log("rect.bottom - viewRect.bottom - 160:"+(rect.bottom - viewRect.bottom -160));
				view.scanAreaMargins = new MarginsWithUnit(
					new NumberWithUnit(rect.left - viewRect.left, MeasureUnit.Pixel),
					new NumberWithUnit(rect.top - viewRect.top, MeasureUnit.Pixel),
					new NumberWithUnit(rect.left - viewRect.left, MeasureUnit.Pixel),
					new NumberWithUnit(Math.abs(rect.bottom - viewRect.bottom), MeasureUnit.Pixel)
				);
		// }
	},
    async cleanup() {
		await context?.frameSource?.switchToDesiredState(FrameSourceState.Off);
		await context?.dispose();
		await context?.removeAllModes();
		//   if (overlay) {
		//     await overlay.setViewfinder(null);
		//     await view?.removeOverlay(overlay);
		//   }
		//   if (cameraSwitchControl) {
		//     view?.removeControl(cameraSwitchControl);
		//     cameraSwitchControl = undefined;
		//   }
		view?.detachFromElement();
		laserLineViewFinder = undefined;
		barcodeCapture = undefined;
		context = undefined;
		view = undefined;
		settings = undefined;
		camera = undefined;
		host?.remove();
		host = undefined;
    },
    connectToElement(element) {
		host = createHostElementIfNeeded();
		host.style.display = "block";
		element.append(host);
    },
    detachFromElement() {
		if (host) {
			host.style.display = "none";
			document.body.append(host);
		}
    },
    async enableCamera(enabled) {

			if (context?.frameSource) {
				await context.frameSource.switchToDesiredState(enabled ? FrameSourceState.On : FrameSourceState.Off);
			}
    },
    async enableScanning(enabled) {
		await barcodeCapture?.setEnabled(enabled);
    },
    async enableSymbology(symbology, enabled) {
		settings.enableSymbology(symbology, enabled);
		await barcodeCapture?.applySettings(settings);
    },
    addBarcodeCaptureListener(listener) {
		barcodeCapture?.addListener(listener);
    },
    removeBarcodeCaptureListener(listener) {
		barcodeCapture?.removeListener(listener);
    },
    getEnabledSymbologies() {
		return settings.enabledSymbologies;
    },
	async ensureBackCameraSelected() {
		try {
			// 既に frameSource ON 前提でも後でもOKなように実装
			const pos = camera?.position;
			if (pos && /user/i.test(String(pos))) {
				const back = await Camera.atPosition?.(CameraPosition?.WorldFacing ?? "worldFacing");
				if (back) {
					await context.setFrameSource(back);
					await context.frameSource?.switchToDesiredState(FrameSourceState.On);
					// 置き換えたカメラを保持
					camera = back;
				}
			}
		} catch (e) {
			console.warn("ensureBackCameraSelected skipped:", e);
		}
	},
};
}

export const SDKContext = createContext({
	loaded: false,
	loading: false,
	sdk: null,
});

function getiOSVersion() {
	if (/iP(hone|od|ad)/.test(navigator.platform)) {
		const match = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
		if (match) {
			return [parseInt(match[1], 10), parseInt(match[2], 10), parseInt(match[3] || 0, 10)];
		}
	}
	return null;
}

export function SDKProvider({ children }) {
	const [loaded, setLoaded] = useState(false);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState();
	const sdk = useMemo(() => createSDKFacade(), []);

	// async function start() {
	const startSDK = async () => {
		// alert("startSDK4");
		setLoading(true);
		// await sdk.initialize();
		try {
			await sdk.initialize();
		} catch (error) {
			console.error("Failed to initialize Scandit SDK:", error);
			// setError(error);
			setError(prev => prev ?? error);  // 初回エラーを保持
			setLoading(false);
			return;
		}
		setLoading(false);
		setLoaded(true);
		await sdk.enableCamera(true).catch((error) => {
			if (error) {
				console.error("Failed to switch camera state:", error);
				// setError(error);
				setError(prev => prev ?? error);  // 初期化エラーがあれば上書きしない
				setLoading(false);
			}
		});
		await sdk.ensureBackCameraSelected();
	}

	// const providerValue = useMemo(() => ({ loading, loaded, sdk, error, startSDK }), [loading, loaded, sdk, error]);
	const providerValue = useMemo(() => ({ loading, loaded, sdk, error, startSDK }), [loading, loaded, sdk, error]);

	useEffect(() => {
		return () => {
		sdk.cleanup();
		};
	}, [sdk]);

	return <SDKContext.Provider value={providerValue}>{children}</SDKContext.Provider>;
}

export function useSDK() {
	const value = useContext(SDKContext);
	if (value.sdk === null) {
		throw new Error("Sdk facade is null. Did you forget to wrap the component with SDKProvider?");
	}
	return value;
}
